import TabOptions from '../options';

export class Model {
  type = null;
  file = null;
}

export class Tab {
  id = 'Documents';
  title = 'Documentos';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
    };
  };
}
export default new Tab();
